import React from "react";
import classes from "./archive.module.css";
import Text from "../text/Text";
import {EditButton} from "../buttons/EditButton";
import DeleteButton from "../buttons/DeleteButton";
import {useArchiveContext} from "../../context/ArchiveContext";

const ArchiveContent = (props) =>{

    const {setDeleteModalOpen, setRedactedArchive,setIsRedacted} = useArchiveContext();

    function openDeleteModal(){
        setDeleteModalOpen(true);
        setRedactedArchive(props.el);
    }

    function openEditModal(){
        setIsRedacted(true);
        setRedactedArchive(props.el);
    }

    return (
        <div className="mb-1 col-md-4">
            <div className={`${classes.archive_card} p-1 m-lg-0 w-100 h-100 d-flex flex-column`}>
                <h5 className="text-center">{props.el.title}</h5>

                <div className="ratio ratio-1x1 mb-2">
                    {props.el.content_type === "VIDEO" ? (
                        <video
                            className="w-100 h-100 object-fit-cover p-0"
                            src={props.el.url}
                            controls
                        />
                    ) : (
                        <img
                            className="w-100 h-100 object-fit-cover p-0"
                            src={props.el.url}
                            alt="img"
                        />
                    )}
                </div>


                <Text text={props.el.description}/>
                <div className="d-flex justify-content-end me-1 mt-auto">
                    <EditButton onClick={openEditModal}/>
                    <DeleteButton onClick={openDeleteModal}/>
                </div>
            </div>
        </div>
    )
}

export default ArchiveContent;